import * as React from 'react';
import { Box, Text } from 'wix-style-react';
import { currencyFormat } from '../../../core';
import { translate } from 'react-i18next';
var MobileLineItem = function (_a) {
    var name = _a.name, quantity = _a.quantity, price = _a.price, description = _a.description, total = _a.total, taxedTotal = _a.taxedTotal, t = _a.t, index = _a.index, taxes = _a.taxes, showTaxPerLineItem = _a.showTaxPerLineItem;
    return (React.createElement(Box, { paddingTop: "6px", direction: "vertical", key: index },
        React.createElement(Box, { backgroundColor: "#F4FAFE", paddingTop: "12px", direction: "vertical", borderRadius: "3px" },
            React.createElement(Box, { paddingLeft: "4%", paddingRight: "4%", display: "flex", align: "space-between" },
                React.createElement(Text, { size: "tiny", weight: 'normal', dataHook: "line-item-name-".concat(index) }, name),
                React.createElement(Text, { size: "tiny", dataHook: "line-item-total-".concat(index) }, showTaxPerLineItem ? taxedTotal : total)),
            React.createElement(Box, { padding: '6px 4% 6px 4%' },
                React.createElement(Text, { size: 'tiny', dataHook: "line-item-quantity-".concat(index) }, t('price-quote.mobile-view.line-items.list.item.quantity', {
                    quantity: quantity,
                    price: price,
                }))),
            showTaxPerLineItem &&
                taxes &&
                taxes.map(function (tax) {
                    var _a, _b;
                    return (React.createElement(Box, { padding: "0 4% 6px 4%" },
                        React.createElement(Text, { size: "tiny", dataHook: "line-item-quantity-".concat(index) }, t('price-quote.view.totals.tax-rate', {
                            name: tax.name,
                            rate: (_b = (_a = tax.rate) === null || _a === void 0 ? void 0 : _a.serializedValue) !== null && _b !== void 0 ? _b : 0,
                        }))));
                }),
            React.createElement(Box, { paddingBottom: "4%", paddingLeft: "4%", paddingRight: "4%" },
                React.createElement(Text, { size: 'tiny', light: true, secondary: true, dataHook: "line-item-description-".concat(index) }, description)))));
};
var LineItems = function (_a) {
    var t = _a.t, lineItems = _a.lineItems, locale = _a.locale, currencyCode = _a.currencyCode, showTaxPerLineItem = _a.showTaxPerLineItem;
    var currency = currencyFormat({ locale: locale, currency: currencyCode });
    return (React.createElement(Box, { direction: "vertical", paddingBottom: "12px" },
        React.createElement(Box, { backgroundColor: "#EAF7FF", height: "36px", verticalAlign: "middle" },
            React.createElement(Box, { paddingLeft: "12px" },
                React.createElement(Text, { size: "medium", weight: "normal", dataHook: "line-items-title" }, t('price-quote.mobile-view.line-items.list.title')))),
        React.createElement(Box, { direction: "vertical" }, lineItems.map(function (_a, index) {
            var name = _a.name, description = _a.description, price = _a.price, quantity = _a.quantity, total = _a.total, taxes = _a.taxes, taxedTotal = _a.taxedTotal;
            return [
                React.createElement(MobileLineItem, { key: index, description: description, quantity: quantity, total: currency(total), taxedTotal: currency(taxedTotal), name: name, price: currency(price), taxes: taxes, t: t, index: index, showTaxPerLineItem: showTaxPerLineItem }),
            ];
        }))));
};
export default translate()(LineItems);
//# sourceMappingURL=LineItems.js.map